let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = (load("8AvOI")).then(() => parcelRequire('cqo8f'));